module.exports = __webpack_public_path__ + "img/facilityInfo_1_1.876e0b6a.jpg";